import { HardDrives } from '@phosphor-icons/react';

/**
 * OfflineAccessCard - Offline status and cache management
 */
export default function OfflineAccessCard({
  isOnline,
  attachmentCacheStats,
  clearingCache,
  onClearAllCache,
  onClearAttachmentsOnly,
}) {
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="font-semibold" style={{ color: 'var(--color-text-primary)' }}>Offline Access</h3>
      </div>
      <div className="card-body">
        <div className="space-y-4">
          {/* Online/Offline status */}
          <div className="flex items-center gap-2">
            <div 
              className="w-2 h-2 rounded-full"
              style={{ backgroundColor: isOnline ? 'var(--color-status-success)' : 'var(--color-status-error)' }}
            />
            <span className="text-sm" style={{ color: 'var(--color-text-secondary)' }}>
              {isOnline ? 'Online' : 'Offline'}
            </span>
          </div>
          
          <p className="text-sm" style={{ color: 'var(--color-text-muted)' }}>
            Your itinerary is stored locally for offline access. You can view and edit your calendar, events, expenses, and budget while offline. Changes will sync automatically when you're back online.
          </p>
          
          {/* Attachment Cache Stats */}
          {attachmentCacheStats && (
            <div 
              className="p-3 rounded-sm"
              style={{ backgroundColor: 'var(--color-bg-surface)' }}
            >
              <div className="flex items-center gap-2 mb-2">
                <HardDrives size={16} style={{ color: 'var(--color-text-muted)' }} />
                <span className="text-sm font-medium" style={{ color: 'var(--color-text-secondary)' }}>
                  Attachment Cache
                </span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span style={{ color: 'var(--color-text-muted)' }}>
                  {attachmentCacheStats.count} file{attachmentCacheStats.count !== 1 ? 's' : ''} cached
                </span>
                <span style={{ color: 'var(--color-text-muted)' }}>
                  {attachmentCacheStats.sizeMB} / {attachmentCacheStats.maxSizeMB} MB
                </span>
              </div>
              <div 
                className="mt-2 h-2 rounded-full overflow-hidden"
                style={{ backgroundColor: 'var(--color-bg-raised)' }}
              >
                <div 
                  className="h-full rounded-full transition-all"
                  style={{ 
                    width: `${Math.min(parseFloat(attachmentCacheStats.percentUsed), 100)}%`,
                    backgroundColor: parseFloat(attachmentCacheStats.percentUsed) > 80 
                      ? 'var(--color-status-error)' 
                      : 'var(--color-brand-primary)',
                  }}
                />
              </div>
              <p className="text-xs mt-2" style={{ color: 'var(--color-text-muted)' }}>
                Attachments for upcoming events (next 7 days) are cached automatically.
              </p>
            </div>
          )}
          
          {/* Cache Actions */}
          <div className="flex flex-wrap gap-2">
            <button
              onClick={onClearAllCache}
              disabled={clearingCache}
              className="btn-secondary btn-sm"
            >
              {clearingCache ? 'Clearing...' : 'Clear All Cache'}
            </button>
            
            {attachmentCacheStats && attachmentCacheStats.count > 0 && (
              <button
                onClick={onClearAttachmentsOnly}
                className="btn-secondary btn-sm"
              >
                Clear Attachments Only
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
